import { useConfigMutation } from "@hooks";

import * as Apis from "../api";

const useCostCenterMutation = (() => {
  return useConfigMutation({ apis: Apis });
})();

export default useCostCenterMutation;
